import React, { useEffect } from 'react';
import profile from './serious.jpg';
import './ChatHeader.css';

const ChatHeader = () => {
  return (
    <div className="ChatHeader">
      <img className="ChatHeader__image" src={profile} alt="foto de perfil" />
      <div className="ChatHeader__text">
        <h5>Juanqui Bot</h5>
      </div>
    </div>
  );
};

export default ChatHeader;
